import { EQuestionType, EQuizMode } from '@constants';
import { TFunction } from 'i18next';

export const mapQuizCsvData = (
  data: { [key: string]: string }[],
  mode: EQuizMode,
  t: TFunction<'ManagerQuizzesTranslations'>
) => {
  if (mode === EQuizMode.QUIZ || mode === EQuizMode.PRACTICE) return mapMultipleChoiceCsvData(data);
  if (mode === EQuizMode.TRUE_FALSE) return mapTrueFalseCsvData(data, t);
  if (mode === EQuizMode.PRACTICAL_CASE) return mapPracticalCaseCsvData(data);
  return { questions: [], description: undefined };
};

const mapMultipleChoiceCsvData = (data: { [key: string]: string }[]) => {
  const questions = data.map(row => {
    return {
      title: row['pregunta'],
      answers: [
        { text: row['respuesta_1'] },
        { text: row['respuesta_2'] },
        ...(row['respuesta_3'] ? [{ text: row['respuesta_3'] }] : []),
        ...(row['respuesta_4'] ? [{ text: row['respuesta_4'] }] : []),
        ...(row['respuesta_5'] ? [{ text: row['respuesta_5'] }] : [])
      ],
      correctAnswer: +row['respuesta_correcta'] - 1,
      type: EQuestionType.MANUAL,
      ...(row['explicacion'] ? { explanation: row['explicacion'] } : {})
    };
  });
  return { questions, description: undefined };
};

const mapTrueFalseCsvData = (
  data: { [key: string]: string }[],
  t: TFunction<'ManagerQuizzesTranslations'>
) => {
  const questions = data.map(row => {
    return {
      title: row['pregunta'],
      answers: [{ text: t('TRUE') }, { text: t('FALSE') }],
      correctAnswer: row['respuesta_correcta'] === 'Verdadero' ? 0 : 1,
      type: EQuestionType.MANUAL,
      ...(row['explicacion'] ? { explanation: row['explicacion'] } : {})
    };
  });
  return { questions, description: undefined };
};

const mapPracticalCaseCsvData = (data: { [key: string]: string }[]) => {
  let description = '';
  const questions = data.map(row => {
    if (!description && row['caso_practico']) description = row['caso_practico'];
    return {
      title: row['pregunta'],
      answers: [
        { text: row['respuesta_1'] },
        { text: row['respuesta_2'] },
        ...(row['respuesta_3'] ? [{ text: row['respuesta_3'] }] : []),
        ...(row['respuesta_4'] ? [{ text: row['respuesta_4'] }] : []),
        ...(row['respuesta_5'] ? [{ text: row['respuesta_5'] }] : [])
      ],
      correctAnswer: +row['respuesta_correcta'] - 1,
      type: EQuestionType.MANUAL,
      ...(row['explicacion'] ? { explanation: row['explicacion'] } : {})
    };
  });
  return { questions, description };
};
